import styled from 'styled-components';
import { media } from 'core/layout';

export const Section = styled.section`
  & > div:last-child {
    flex-wrap: wrap;
    align-items: stretch;

    & > div {
      flex: 0 0 ${(1/3) * 100}%;

      /* IE fix */
      max-width: ${(1/3) * 100}%;

      ${media.tablet`
        flex: 0 0 ${(1/2) * 100}%;
        max-width: ${(1/2) * 100}%;
      `};

      ${media.tabletSmall`
        &:not(:last-child) {
          margin-bottom: 16px;
        }

        max-width: none;
      `};

      @media print {
        flex: 0 0 ${(1/2) * 100}%;
        max-width: ${(1/2) * 100}%;
        page-break-inside: avoid;
      }
    }

    & > div > div {
      height: 100%;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/modules/CardsSection/styled.js